import { InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import { Spinner } from 'mode-shared/components/Spinner';

export const Input = ({
  className,
  loading,
  ...props
}: { className?: string; loading?: boolean } & InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <div className="relative">
      <input
        disabled={props.disabled || loading}
        className={clsx(
          'font-primary px-4 py-2 w-full max-w-[200px] bg-grey-800 text-neutral-100 border border-grey-900 rounded-lg focus:outline-none focus:border-neutral-500',
          (props.disabled || loading) && 'opacity-50',
          className
        )}
        {...props}
      />
      {loading && <Spinner size={20} className="absolute right-2 top-1/2 -translate-y-1/2" />}
    </div>
  );
};
